/* eslint-disable */
import config from '../../../config'
import styles from './index.module.scss'
import { useState, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PlayIcon } from '../../../icons'
import { PageContext } from '../../../context/PageContextProvider'
import VideoAPI from '../../../api/video'
import Loading from '../loading'

const Video = () => {
  const location = useLocation()
  const [play, setPlay] = useState(false)
  const { language } = useContext(PageContext)
  const [video, setVideo] = useState([])
  const [load, setLoad] = useState(false)
  useEffect(() => {
    (async () => {
      try {
        const { data } = await VideoAPI.getAll()
        const isAbout = location.pathname.includes('about')
        const datum = Array.isArray(data)
          ? isAbout
            ? data.find((v) => v.pageType === 'about') || data[1] || data[0]
            : data.find((v) => v.pageType === 'home') || data[0] || data[1]
          : null
        await setVideo(datum)
        await setLoad(true)
      } catch (e) {
        console.error('Video error:', e)
        await setLoad(true)
      }
    })()
  }, [location.pathname])
  const linkBuilder = (url) => {
    if (!url) return ''
    return url.startsWith('http') ? url : config.API_URL + url
  }
  const Player = () => {
    setPlay(true)
  }
  const getYoutubeEmbedUrl = (url) => {
    if (!url) return ''
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    const match = url.match(regExp)
    const videoId = match && match[2].length === 11 ? match[2] : null
    if (!videoId) return url
    return play
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
      : `https://www.youtube.com/embed/${videoId}?rel=0`
  }

  const rawUrl =
    language === 'AZ' || language === 'TR'
      ? video?.youtubeLinkAz || video?.link?.AZ || video?.youtubeLinkTr
      : language === 'RU'
      ? video?.youtubeLinkRu || video?.link?.RU
      : video?.youtubeLinkEng || video?.link?.ENG

  const hasCustomCover = Boolean(video?.showImage && video?.photoLocation)

  return load ? (
    <section className={styles.container}>
      <div className={styles.content}>
        <div className={styles.text}>
          <span>{video?.title ? video.title[language] : ''}</span>
          <h2>{video?.subTitle ? video.subTitle[language] : ''}</h2>
          <div
            dangerouslySetInnerHTML={{
              __html: video?.description ? video.description[language] : '',
            }}
          />
        </div>
        <div className={styles.video}>
          {hasCustomCover && !play ? (
            <figure
              onClick={() => Player()}
              style={{
                backgroundImage: `url('${linkBuilder(video?.photoLocation)}')`,
              }}
            />
          ) : null}
          <iframe
            id="video-value"
            src={getYoutubeEmbedUrl(rawUrl)}
            loading="lazy"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{
              width: '100%',
              height: '100%',
              pointerEvents: 'auto',
            }}
          />

          {hasCustomCover && !play ? (
            <span>
              <PlayIcon onClick={() => Player()} />
            </span>
          ) : null}
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}
export default Video
